import {connect} from 'react-redux';
import ValidationIdResetView from '../../components/views/mx/ValidationIdResetView';
import * as ValidationIdDataStepActions from '../../actions/mx/ValidationIdDataStepActions';
import {State} from '../../../../types/mx/reducers';
import {
    ValidationIdResetDispatchProps, ValidationIdResetStateProps,
} from '../../types/mx/containers';
import * as ModalActions from '../../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';

const mapStateToProps = (state: State): ValidationIdResetStateProps => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ValidationIdResetDispatchProps => {
    return {
        onPressResetConfirm: () => {
            dispatch(ValidationIdDataStepActions.VALIDATION_ID_RESET_ACTION.action());
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const ValidationIdResetContainer = connect(
    mapStateToProps, mapDispatchToProps,
)(ValidationIdResetView);

export default ValidationIdResetContainer;
